export default "__VITE_ASSET__DVwBs3SQ__"